function _defineProperty(obj, key, value) {
  if (key in obj) {
    Object.defineProperty(obj, key, {
      value: value,
      enumerable: true,
      configurable: true,
      writable: true
    });
  } else {
    obj[key] = value;
  }
  return obj;
}
export default (function (_ref) {
  var colors = _ref.colors,
    mediaQueries = _ref.mediaQueries;
  return {
    container: _defineProperty({
      padding: '15px 15px 0 15px'
    }, mediaQueries.breakpointLarge, {
      padding: '0'
    }),
    heading: {
      '& span': {
        color: colors.darkGray,
        fontSize: '22px',
        lineHeight: '30px !important'
      }
    },
    icon: {
      margin: '10px auto 0',
      '& svg': {
        maxHeight: '80px',
        fill: colors.titleIconsColor
      }
    },
    contact: {
      alignItems: 'center',
      color: colors.primary,
      display: 'flex',
      float: 'none',
      fontSize: '22px',
      margin: '20px 0',
      justifyContent: 'center'
    },
    contactIcon: {
      float: 'left',
      margin: '0 10px 0',
      '& svg': {
        height: '20px',
        width: '20px',
        fill: colors.contactIconsColor
      }
    },
    contactLink: {
      float: 'left'
    },
    workingHours: {
      color: colors.lightGrayDescription,
      fontSize: '14px'
    }
  };
});